import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { DropList } from '@amzn/dvui/dist/DropList'
import { Icon, IconType } from '@amzn/dvui/dist/Icon'
import { Badge, badges } from '@amzn/dvui/dist/Badge'
import * as st from './seasons.module.scss'
import { TextLocalizer } from '../localizer/localizer'
import { StringId } from '../localizer/stringId'
import { isLiveEntityType } from '../../utils/entityTypes'
import { safeBoolean } from '../../utils/utils'

type Season = {
  titleId: string,
  seasonLink: string,
  detail?: WpsRuntime.atv.wps.DetailFragmentModelProps,
  self?: WpsRuntime.atv.wps.SelfFragmentModelProps
}

export type DropListLink = {
  text: React.ReactNode,
  href: string,
  isHighlighted: boolean,
  children: React.ReactNode
}

type isHighlightedProps = {
  asins: WpsRuntime.atv.wps.ASINs
  gti: WpsRuntime.atv.wps.GTI
  compactGTI: WpsRuntime.atv.wps.CompactGTI
  pageTitleId: WpsRuntime.atv.wps.TitleID
}
const isHighlighted = ({ asins, gti, compactGTI, pageTitleId }: isHighlightedProps) =>
  Boolean(asins.includes(pageTitleId) || pageTitleId === gti || pageTitleId === compactGTI)

const showPrimeLogo = (season: Season, isRetail: boolean) =>
  safeBoolean(isRetail && season.detail && season.detail.isPrime)

const convertSeasonsToLinks = (
    seasons: Season[],
    pageTitleId:  WpsRuntime.atv.wps.TitleID,
    isRetail: boolean
  ) =>
  seasons.reduce((filtered, season) => {
    if (!(season && season.self && safeBoolean(season.self.isLaunched) && season.self.link)) {
      return filtered
    }

    const self = season.self
    const { asins, gti, compactGTI, sequenceNumber } = self
    filtered.push({
      text: (
        <TextLocalizer
          stringID={StringId.AVOD_DP_season_selector}
          replace={{ seasonNumber: sequenceNumber !== undefined ? sequenceNumber.toString() : "" }}
        />
      ),
      href: season.seasonLink,
      isHighlighted: isHighlighted({ asins, gti, compactGTI, pageTitleId }),
      children: showPrimeLogo(season, isRetail) ? <Icon className={st.primeLogo} use={IconType.LOGO_PRIME} /> : null
    })
    return filtered
  }, [] as DropListLink[])

type SeasonProps = {
  season: Season,
}
export const Season = ({ season }: SeasonProps) => {
  const seasonNumber = season.self && season.self.sequenceNumber && season.self.sequenceNumber.toString() || ""

  return (
    <Badge use={badges.TEXT} className={st.single}>
      <TextLocalizer stringID={StringId.AVOD_DP_season_selector} replace={{ seasonNumber }} />
    </Badge>
  )
}

export type SeasonsSelectorProps = {
  seasons?: Season[]
  pageTitleId?: WpsRuntime.atv.wps.TitleID
  isRetail?: boolean
}
export const Seasons = ({ seasons, pageTitleId = '', isRetail = false }: SeasonsSelectorProps) => {
  // We don't show season selector for Live Event Titles
  if (!seasons || seasons.length === 0 ||
    seasons[0] && seasons[0].detail && seasons[0].detail!.entityType && isLiveEntityType(seasons[0].detail!.entityType)) {
    return null
  }

  if (seasons.length === 1 && seasons[0] && seasons[0].self && safeBoolean(seasons[0].self!.isLaunched)) {
    return <Season season={seasons[0]} />
  }

  return (
    <div className={`dv-node-dp-seasons ${st.selector}`}>
      <DropList
        links={convertSeasonsToLinks(seasons, pageTitleId, isRetail)}
        customDropListID="av-atf-season-selector"
      />
    </div>
  )
}